/**
 * Vault Documents arche constants (Phase 12d-1c).
 */

export const ARCHE_ID = 'arche_vault_documents';
